import React from 'react';
import { withPrefix, Link } from 'gatsby';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import Layout from '../components/Layout';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';


const SolutionsPage = ({ data }) => {
  const { markdownRemark: post } = data;
  console.log(post);
  return (
    <Layout>
      <Helmet>
        <html lang={post.frontmatter.locale === 'en' ? 'en' : 'de'} />    
        <title>
          { 
            post.frontmatter.locale === 'en' ?
              post.frontmatter.title + ' - Solutions - presono' :
              post.frontmatter.title +  ' - Lösungen - presono'
          }
        </title>
        <meta
          name="description"
          content={post.frontmatter.subtext}
        />

      </Helmet>
      <Navigation langSwitch={post.frontmatter.langSwitch} locale={data.markdownRemark.frontmatter.locale} />
      <section className="solutions sub features">
        <div className="solutions-header">
          <section className="headliner top" style={{ backgroundImage: `url(${'/img/'+ post.frontmatter.headlineImage.relativePath})` }}>
            <div className="container">
              <div class="column">
                <ReactMarkdown source={ post.frontmatter.headline } />
                <p>
                  { post.frontmatter.subtext }
                </p>
              </div>
            </div>
          </section>
        </div>
        {/*
        <section class="customer-example">
          <div class="container">
            <div class="tile is-ancestor">
              <div class="tile">
                <div class="tile is-parent is-12">
                  <div class="inner">
                    <div class="columns nomargin">
                      <div class="column teal3 left is-8">
                      </div>
                      <div class="column right is-4">
                        <div class="content">
                          <h3>Greiner Packaging<br /> setzt auf presono im ganzen Unternehmen</h3>
                          <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua</p>
                        </div>
                        <div class="circle-ar">
                          <div class="icon-ar">
                            <div class="arrow"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        */}
        {/*
        <section className="headliner">
          <div className="container">
            <div class="column">
              <h2>
              So hilft presono in Ihrem <span class="underline">Unternehmen</span>
              </h2>
              <p>
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam<br /> nonumy eirmod tempor invidunt ut labore et dolore magna
              </p>
            </div>
          </div>
        </section>
        */}
        <section class="content-right">
          <div class="container">
            <div class="columns">
              <div class="column is-6">
                <div className="feature-text">
                  <ReactMarkdown source={ post.frontmatter.feature1Headline } />
                  <p>
                    { post.frontmatter.feature1Text }
                  </p>
                </div>
              </div>
              <div class="column is-6">
                <figure class="image highlight-variant-1">
                  <img src={withPrefix('/img/'+ post.frontmatter.feature1Image.relativePath)} alt="Feature" />
                </figure>
              </div>
            </div>
          </div>
        </section>
        <section class="content-left">
          <div class="container">
            <div class="columns">
              <div class="column is-6">
                <figure class="image highlight-variant-3">
                  <img src={withPrefix('/img/'+ post.frontmatter.feature2Image.relativePath)} alt="Feature" />
                </figure>
              </div>
              <div class="column is-6">
                <div className="feature-text">
                  <ReactMarkdown source={ post.frontmatter.feature2Headline } />
                  <p>
                    { post.frontmatter.feature2Text }
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="content-right">
          <div class="container">
            <div class="columns">
              <div class="column is-6">
                <div className="feature-text">
                  <ReactMarkdown source={ post.frontmatter.feature3Headline } />
                  <p>
                    { post.frontmatter.feature3Text }
                  </p>
                </div>
              </div>
              <div class="column is-6">
                <figure class="image highlight-variant-2">
                  <img src={withPrefix('/img/'+ post.frontmatter.feature3Image.relativePath)} alt="Feature" />
                </figure>
              </div>
            </div>
          </div>
        </section>
        <section className="headliner">
          <div className="container">
            <div class="column">
              <ReactMarkdown source={ post.frontmatter.solutionsHeadline } />
              <p>
                { post.frontmatter.solutionsSubtext }
              </p>
              <Link to={ post.frontmatter.locale === "en" ? "/solutions" : "/de/solutions" } class="button is-rounded customers-button">{ post.frontmatter.solutionsButton }</Link>
            </div>
          </div>
        </section>
      </section>
      <Newsletter newsletter={post.frontmatter} locale={post.frontmatter.locale} />
      <Footer locale={post.frontmatter.locale} />
    </Layout>
  );
};

SolutionsPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
};

export default SolutionsPage;

export const pageQuery = graphql`
  query SolutionsPageByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      frontmatter {
        title
        locale
        headline
        subtext
        headlineImage  {
          name
          relativePath
        }
        feature1Headline
        feature1Text
        feature1Image  {
          name
          relativePath
        }
        feature2Headline
        feature2Text
        feature2Image  {
          name
          relativePath
        }
        feature3Headline
        feature3Text
        feature3Image  {
          name
          relativePath
        }
        solutionsHeadline
        solutionsSubtext
        solutionsButton
        langSwitch
      }
    }
  }
`;
